import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import AppPreloader from "@/components/common/other/AppPreloader.vue";
import { useGeneralStore } from "@/stores/general";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppPreloaderContainer',
  setup(__props) {

const general = useGeneralStore();

return (_ctx: any,_cache: any) => {
  return (_unref(general).getLoading && _unref(general).getShowLargePreloader)
    ? (_openBlock(), _createBlock(AppPreloader, { key: 0 }))
    : _createCommentVNode("", true)
}
}

})